export * from '@thalesrc/js-utils/object/clone';
export * from '@thalesrc/js-utils/object/compact';
export * from '@thalesrc/js-utils/object/deepest';
export * from '@thalesrc/js-utils/object/deep-freeze';
